var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"variant":_vm.variant},on:{"click":function($event){return _vm.unsubscribe()}}},[_c('svg-icon',{attrs:{"label":_vm.$t('newsletter.unsubscribe'),"name":"r-bell-slash","variant":"fc-d8"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }